// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  env: 'Development',
  ApiUrl:  'https://ccpzposapidev.clavisco.com/',
  ReportManager: 'https://rptmanagertest.clavisco.com/',
  SentryDsn: 'https://92c25ac39346feecf8a92fe19799126b@o4511328163725312.ingest.us.sentry.io/4511951119974400'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
